import React from "react";

import Header from "../components/header";
import Footer from "../components/footer";
import Whatsapp from "../components/whatsapp";

import "../style/partnerForm.css";

function PartnerFormPage() {
    return (
        <React.Fragment>
            <Header />

            <div className="partner-form">
                <b className="title">Formulário de cadastro</b>

                <div className="form-wrapper">
                    <span>NOME DA EMPRESA</span>
                    <input type="text" name="nameInput" id="nameInput" placeholder="Exemplo LTDA" />
                </div>
                <div className="form-wrapper">
                    <span>CNPJ</span>
                    <input type="text" name="docIdInput" id="docIdInput" placeholder="xx.xxx.xxx/0001-xx" />
                </div>
                <div className="form-wrapper splitted">
                    <div className="middle">
                        <span>E-MAIL</span>
                        <input type="email" name="emailInput" id="emailInput" placeholder="exemplo0@gmail.com" />
                    </div>
                    <div className="middle">
                        <span>CONFIRME SEU E-MAIL</span>
                        <input type="email" name="emailConfirmInput" id="emailConfirmInput" placeholder="exemplo0@gmail.com" />
                    </div>
                </div>
                <div className="form-wrapper">
                    <span>CONTATO</span>
                    <input type="text" name="phoneInput" id="phoneInput" placeholder="00 1234-5678" />
                </div>
                <div className="form-wrapper splitted">
                    <div className="four-column">
                        <span>NICHO DE ATUAÇÃO</span>
                        <select name="nichoInput" id="nichoInput">
                            <option value="provedor">Provedor de internet (ISP)</option>
                            <option value="revendedor">Revendas de telefonia ou chips corporativos</option>
                            <option value="marketing">Marketing e Vendas</option>
                            <option value="ecommerce">E-commerce</option>
                            <option value="financas">Finanças e Negócios</option>
                        </select>
                    </div>
                    <div className="two-column">
                        <span>ESTADO</span>
                        <select name="ufInput" id="ufInput">
                            <option value="ac">AC</option>
                            <option value="al">AL</option>
                            <option value="ap">AP</option>
                            <option value="am">AM</option>
                            <option value="ba">BA</option>
                            <option value="ce">CE</option>
                            <option value="df">DF</option>
                            <option value="es">ES</option>
                            <option value="go">GO</option>
                            <option value="ma">MA</option>
                            <option value="mt">MT</option>
                            <option value="ms">MS</option>
                            <option value="mg">MG</option>
                            <option value="pa">PA</option>
                            <option value="pb">PB</option>
                            <option value="pr">PR</option>
                            <option value="pe">PE</option>
                            <option value="pi">PI</option>
                            <option value="rj">RJ</option>
                            <option value="rn">RN</option>
                            <option value="rs">RS</option>
                            <option value="ro">RO</option>
                            <option value="rr">RR</option>
                            <option value="sc">SC</option>
                            <option value="sp">SP</option>
                            <option value="se">SE</option>
                            <option value="to">TO</option>
                        </select>
                    </div>
                </div>
                <div className="form-wrapper">
                    <span>CIDADE</span>
                    <input type="text" name="cityInput" id="cityInput" placeholder="Neópolis" />
                </div>

                <div className="form-wrapper">
                    <span>CONTE-NOS MAIS SOBRE SUA EMPRESA</span>
                    <textarea name="aboutInput" id="aboutInput"></textarea>
                </div>
            </div>

            <div className="button-wrapper">
                <button>Enviar formulário</button>
            </div>

            <Whatsapp/>
            <Footer />
        </React.Fragment>
    )
}

export default PartnerFormPage;